import React, { useState } from "react";
import bgimage from "../../assets/img/LoginScreen.jpg";
import logo from "../../assets/img/aadi-login-logo.png";
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Home from "../pages/Home";
import Footer from "../reusables/Footer";
import { loginRequest } from "./authConfig"; // make sure this points to your loginRequest

const Login = () => {
  const { instance } = useMsal(); // Access MSAL instance from context

  const login = async () => {
    try {
      // const loginResponse = await instance.loginPopup(); // Trigger login popup
      const loginResponse = await instance.loginPopup(loginRequest);

      console.log("Login successful", loginResponse);
      
      // Get user details
      const account = loginResponse?.account;
      const accessToken = loginResponse?.accessToken; // Access token for API calls
      console.log("accessToken",accessToken)
      const idToken = account?.idToken;
      const userEmail = loginResponse?.idTokenClaims?.preferred_username;
      const userName = loginResponse?.idTokenClaims?.name;
      
      // Store in localStorage
      localStorage.setItem("myemail", userEmail?.toLowerCase());
      localStorage.setItem("userName", userName);
      localStorage.setItem(
        "access-token-storage",
        JSON.stringify({ accessToken })
      );
      localStorage.setItem(
        "id-token-storage",
        JSON.stringify({ idToken })
      );

      // Optionally redirect to home or update state for authenticated view
    } catch (error) {
      console.error("Login failed", error);
      alert("Login failed. Please try again.");
    }
  };

  return (
    <div>
      <AuthenticatedTemplate>
        <Home />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="Buttons">
          <div className="loginPage">
            <div className="login_body_content">
              <div className="bg-white dark:bg-gray-900 bgColor">
                <div className="login_body_grid">
                  <div
                    style={{
                      backgroundImage: `linear-gradient(rgba(40,57,120,0.5), rgba(40,57,120,0.5)),url(${bgimage})`,
                    }}
                    className="hidden bg-cover lg:block login_bg_image"
                  >
                    <div className="login_info"></div>
                  </div>

                  <div style={{ position: "relative" }} className="right_grid_align bgColor">
                    <div className="flex-1">
                      <div className="text-center">
                        <span className="text-4xl font-bold text-center text-gray-700 dark:text-white MarsLogo">
                          <img width={120} src={logo} alt="img" />
                        </span>

                        <p className="left_grid_text left_margin loginText1 formLableText1">
                          Sign in to access your account
                        </p>
                      </div>

                      <div className="mt-8">
                        <div className="mt-6">
                          <button className="btn_login" onClick={login}>
                            Sign in
                          </button>
                        </div>
                      </div>

                      <div
                        style={{
                          width: "70%",
                          paddingTop: "1rem",
                          display: "block",
                          margin: "auto",
                        }}
                      >
                        <span
                          id="Login_herf"
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <a
                            rel="noreferrer"
                            target={"_blank"}
                            className="loginText1 formLableText1"
                            style={{ textDecoration: "none" }}
                            href="mailto:anshuman.bhar@aaysanalytics.com?subject=Need Help On Sign in On  CFO Decision Intelligence Tool"
                          >
                            {" "}
                            Need Access ?
                          </a>
                        </span>
                      </div>
                    </div>

                    <Footer className="LoginTextCls" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Login;
